import React from 'react';
import PropTypes from 'prop-types';

import stringHelper from 'utils/stringHelper';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import LoadingButton from 'components/Shared/LoadingButton';


class QualificationCodeAbsentAviseNeRepondPasInnerForm extends React.Component {


    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState(props.open);
    }

    getInitialState = (open) => {
        const initialState = {
            open: open,
            date: '',
            telephone: '',
            commentaire: ''
        };
        return initialState;
    }
    


    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };
        
        this.setState(newState);

    }


    handleClickAnswer = (event) => {
        const newState = {
            ...this.state,
            open: true
        };

        this.setState(newState);
    }

    handleClickCancel = (event) => {
        this.setState(this.getInitialState(this.props.open));

        if (this.props.onClickCancelFallback) {
            this.props.onClickCancelFallback();
        }
    }

    handleClickSave = (event) => {
        const { date, telephone, commentaire } = this.state;

        this.props.onClickSave(date, telephone, commentaire);
    }


    render() {
        const { isAdding } = this.props;

        const { open, date, telephone, commentaire } = this.state;


        let sauvegardable = !stringHelper.isNullOrWhitespace(date) && !stringHelper.isNullOrWhitespace(telephone);
        

        return (

            <React.Fragment>

                <div hidden={open || isAdding}>
                    <Button onClick={this.handleClickAnswer} variant="outlined" >Répondre</Button>
                </div>


                <Card hidden={!open && !isAdding}>

                    <CardContent sx={{ minWidth: '500px' }}>

                        <Stack mt={1} spacing={1}>
                            <TextField
                                id="date"
                                name="date"
                                label="Date de relivraison souhaitée"
                                type="date"
                                value={date}
                                onChange={this.handleChange}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />

                            <TextField
                                required
                                id="telephone"
                                name="telephone"
                                label="Téléphone"
                                placeholder="Téléphone"
                                multiline
                                margin="normal"
                                value={telephone}
                                onChange={this.handleChange}
                            />


                            <TextField
                                id="commentaire"
                                name="commentaire"
                                label="Commentaire"
                                placeholder="Commentaire"
                                multiline
                                margin="normal"
                                value={commentaire}
                                onChange={this.handleChange}
                            />
                        </Stack>



                    </CardContent >




                    <CardActions sx={{ justifyContent: 'right' }}>
                        <Button onClick={this.handleClickCancel} color="primary" >Annuler</Button>
                        <LoadingButton
                            disabled={!sauvegardable || isAdding}
                            onClick={this.handleClickSave}
                            label="Enregistrer"
                            pending={isAdding}
                        />
                    </CardActions>


                </Card>
            </React.Fragment>
        );
    }
}
QualificationCodeAbsentAviseNeRepondPasInnerForm.propTypes = {
    isAdding: PropTypes.bool.isRequired
};

export default QualificationCodeAbsentAviseNeRepondPasInnerForm;